import { PatientAppointment } from '../../../../../../../services/appointment/types';
import { RectangleChip } from '../../../../../../shared/chip/rectangle-chip.styles';

export const getSpentChip = (appt: PatientAppointment) => {
  return (
    <RectangleChip
      className="spent-chip"
      sx={{
        backgroundColor: appt.spend && appt.spend > 0 ? 'rgba(32, 153, 37, 1)' : 'rgba(173, 173, 173, 1)'
      }}
    >
      ${appt.spend || 0}
    </RectangleChip>
  );
};
